import axios from '../../axios';
import * as TYPES from '../types';

const state = {
  receiptCounts: [],
};
const getters = {
  receiptCounts: state => state.receiptCounts,
};
const mutations = {
  [TYPES.SET_RECEIPT_COUNTS](state, payload) {
    state.receiptCounts = payload;
  },
};
const actions = {
  /**
   * 获取发票余额
   * @param commit
   * @param role
   * @param params
   */
  getReceiptCounts: ({commit},{role,params}) => {
    commit(TYPES.SET_LOADING, true);
    if(role==='user'){
      axios
        .get("/companies/me")
        .then(response => {
          let temp=[];
          temp.push(response.data);
          commit(TYPES.SET_RECEIPT_COUNTS, temp);
          commit(TYPES.SET_LOADING, false);
        })
        .catch(reason => {
          commit(TYPES.SET_ERROR, reason.message);
          commit(TYPES.SET_LOADING, false);
        });
    }else{
      axios
        .get("/companies",{params: {...params,sort:'createDate,desc'}})
        .then(response => {
          commit(TYPES.SET_RECEIPT_COUNTS, response.data.data);
          commit(TYPES.SET_LOADING, false);
        })
        .catch(reason => {
          commit(TYPES.SET_ERROR, reason.message);
          commit(TYPES.SET_LOADING, false);
        });
    }

  },
};

export default {
  state,
  getters,
  mutations,
  actions
}